export default "<div class=\"layout\">\n    <router-outlet></router-outlet>\n</div>"